const React = require('react');
const ClipboardText = require('./index');
const Ripple = require('../Ripple');


const DEFAULT_TOOLTIP = (
  <div className="layoutRow fhaC fvaC hmin40 pv10 ph20">
    Text has been copied to clipboard
  </div>
);

module.exports = (props) => {
  return (
    <ClipboardText
      component={Ripple}
      tooltip={DEFAULT_TOOLTIP}
      {...props}
    />
  );
};
